Namespace 'Customer.Ticket.Integration'

class Customer.Ticket.Integration.BaseIntegration extends Backbone.Model
  $content: $('#content')

  showLoadingAnimation: ->
    @$content.addClass 'processing-all-page'

  hideLoadingAnimation: ->
    @$content.removeClass 'processing-all-page'

  initialize: (attributes, {ticket}) ->
    @ticket = ticket

  onClickExternalCrm: (profile_id) =>
    @exportToCrm(profile_id)

  exportToCrm: (profile_id) =>
    identifier = @_identifier()
    _title = I18n.t(
      'customer.dashboard.conversations.details.integrations.crm_create_case_are_you_sure',
      identifier: _.str.capitalize(identifier)
    )
    swal(
      {
        title: _title
        type: 'warning'
        showCancelButton: true
        confirmButtonClass: 'btn-danger'
        confirmButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.confirm')
        cancelButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.cancel')
        closeOnConfirm: true,
        closeOnCancel: true,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      },
      (isConfirm) =>
        if isConfirm
          @showLoadingAnimation()
          $.ajax
            type: 'POST'
            url: "/customer/conversations/export_to_crm/#{@ticket.id}"
            data: {profile_id: profile_id, identifier: identifier}
            success: @_onSuccess
            error: @_onRequestError
    )

  _onSuccess: (response) =>
    if response.success
      @setExternalCrmIds(response.result)
      @trigger('ticket:export:success', response)
    else
      @_onError(response)
    @ticket.trigger('exportToCrm:finished', response)
    @hideLoadingAnimation()

  _onError: (response) =>
    @_onErrorAlert(response)
    @hideLoadingAnimation()

  _onErrorAlert: (response) ->
    showError("#{@_integrationErrorMessage()}: #{response.message}")

  _onRequestError: (response) =>
    @_onRequestErrorAlert(response)
    @hideLoadingAnimation()

  _onRequestErrorAlert: (response) =>
    showError("#{@_integrationErrorMessage()}: #{response.statusText}")

  _integrationErrorMessage: () =>
    I18n.t(
      'customer.dashboard.conversations.details.integrations.crm_create_case_error_message'
    , {identifier: @_identifier()}
    )

  setExternalCrmIds: ({id, external_url}) =>
    @set('crm_id', id)
    @set('crm_external_url', external_url)

  mandatoryFields: =>
    @get('crm_mandatory_fields')

  canUpdate: =>
    @ticket.canUpdate()

  canCreateExternalTicket: =>
    @get('has_permission_to_create_in_crm') &&
      @get('can_create_external_ticket')

  isLinkedToCrm: =>
    !_.isEmpty(@get('crm_id'))

  translations: =>
    @get('translations')
